import r from "../managers/braze-instance.js";
import ra from "./push-manager-factory.js";
export function requestPushPermission(n, o) {
  if (r.rr())
    return ra.ra().subscribe((o, t, e) => {
      const s = r.nn();
      s && s.requestImmediateDataFlush(), "function" == typeof n && n(o, t, e);
    }, o);
}
